import React, { useRef } from "react";
import { Modal, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { Form } from "@workspace/common";
import { toast } from "react-toastify";
import {
  changeStatus,
  offerStatus,
  tagJob,
} from "@workspace/job/src/store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  JOB_STAGE_IDS,
  JOB_STAGE_STATUS,
} from "@workspace/job/src/components/JobListing/JobListingConstants";
import { useUserAuth } from "@workspace/login";

function ELCModal({
  selectedCandidate,
  elcModalOpen,
  setElcModalOpen,
  modalForm,
  formTemplate,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getAllUserGroups } = useUserAuth();
  const form = useSelector((state) => state?.JobFormReducer?.form);
  const jobTagMeta = useSelector((state) => state.JobStageReducer.jobTagMeta);
  const offerStatusMeta = useSelector(
    (state) => state.PreOfferCandidateReducer.offerStatusMeta
  );
  const changeStatusMeta = useSelector(
    (state) => state.PreOfferCandidateReducer.changeStatusMeta
  );

  const formikRef = useRef(null);

  const handleClose = () => {
    setElcModalOpen(false);
  };

  const handleFormSubmit = async (
    event,
    values,
    newValues,
    buttonNameHook,
    formStateHook,
    rerenderTable
  ) => {
    if (modalForm === "reject_preoffer") {
      const payload = {
        jobId: selectedCandidate?.jobEnity?.id,
        jobStageId: JOB_STAGE_IDS?.RELEASE_PREOFFERVERIFICATION,
        status: JOB_STAGE_STATUS?.IN_PROGRESS,
        candidateId: selectedCandidate?.candidate?.id,
        formData: JSON.stringify(newValues),
        formId: parseInt(form?.formId),
        jobType: "pre_offer_verification_correction",
        stepName: "Pre-Offer Verification",
        subStepName: "Rejected",
      };
      dispatch(tagJob({ payload, navigate }));
    } else if (modalForm === "review_offer") {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status:
          newValues?.status === "Reviewed"
            ? JOB_STAGE_STATUS.REVIEWED
            : JOB_STAGE_STATUS.CORRECTION_NEEDED,
        offerType: "offer_review",
      };
      dispatch(offerStatus(payload));
    } else if (modalForm === "approve_offer") {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status:
          newValues?.status === "Approve"
            ? JOB_STAGE_STATUS.APPROVED
            : JOB_STAGE_STATUS.REJECTED,
        offerType: "offer_approval",
      };
      dispatch(offerStatus(payload));
    } else if (modalForm === "offer_acceptance") {
      if (
        newValues?.status === "Accepted" &&
        newValues?.requiredForOnboarding?.length === 0
      ) {
        toast.error("Please select at least one checkbox to proceed.");
        return;
      }
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status: newValues?.status,
        offerType: "offer_acceptance",
      };
      dispatch(offerStatus(payload));
    } else if (
      modalForm === "bgc_status_update" ||
      modalForm === "mom_bgc_status_update" ||
      modalForm === "security_clearance_update" ||
      modalForm === "visa_update"
    ) {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status: newValues?.status,
        offerType: modalForm,
      };
      dispatch(offerStatus(payload));
    } else if (modalForm === "onboarding_upload_done") {
      dispatch(
        changeStatus({
          id: selectedCandidate?.id,
          status: "ONBOARDING_DOCUMENTS_UPLOADED",
        })
      );
    } else if (modalForm === "onboarding_date") {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status: JOB_STAGE_STATUS.COMPLETED,
        offerType: "onboarding_complete",
      };
      dispatch(offerStatus(payload));
    } else if (modalForm === "end_contract") {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status: JOB_STAGE_STATUS.COMPLETED,
        offerType: "end_contract",
      };
      dispatch(offerStatus(payload));
    } else if (modalForm === "extend_contract") {
      const payload = {
        preOfferId: selectedCandidate?.id,
        formData: JSON.stringify(newValues),
        formId: null,
        status: JOB_STAGE_STATUS.COMPLETED,
        offerType: "extend_contract",
      };
      dispatch(offerStatus(payload));
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={elcModalOpen} toggle={handleClose} centered={true}>
        <ModalBody className="pb-0 pt-4">
          <Form
            template={formTemplate}
            userDetails={getAllUserGroups()}
            country={null}
            onSubmit={handleFormSubmit}
            onFormFieldsChange={null}
            errorMessage={null}
            view={false}
            ref={formikRef}
          />
        </ModalBody>
        <ModalFooter className="pt-0 pe-4 ps-4">
          <div className="d-flex flex-row gap-2 w-100">
            <Button
              className="btn btn-light w-50"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
              disabled={
                jobTagMeta?.isLoading ||
                offerStatusMeta?.isLoading ||
                changeStatusMeta?.isLoading
              }
            >
              Cancel
            </Button>
            <Button
              className="btn btn-success w-50"
              onClick={() => formikRef.current.formik.submitForm()}
              disabled={
                jobTagMeta?.isLoading ||
                offerStatusMeta?.isLoading ||
                changeStatusMeta?.isLoading
              }
            >
              {jobTagMeta?.isLoading ||
              offerStatusMeta?.isLoading ||
              changeStatusMeta?.isLoading ? (
                <Spinner size="sm" color="light" />
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default ELCModal;
